import { supabase } from '@/lib/supabase';

/** Chama a função administrativa no servidor. O token do usuário logado é enviado automaticamente. */
export async function adminCall(action, id, data) {
  const { data: res, error } = await supabase.functions.invoke('admin-users', {
    body: { action, id, data },
  });
  if (error) {
    let msg = 'Não foi possível concluir a ação.';
    try {
      const j = await error.context.json();
      if (j?.error) msg = j.detail ? `${j.error} (${j.detail})` : j.error;
    } catch (e) {
      // sem corpo de erro
    }
    throw new Error(msg);
  }
  if (res?.error) throw new Error(res.error);
  return res;
}